import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TitleSection from '~/components/atoms/Editorial/TitleSection.vue';
import MainImage from '~/components/atoms/Editorial/MainImage.vue';
import Cta from '~/components/atoms/Cta.vue';
import SubtitleSection from '~/components/atoms/Editorial/SubtitleSection.vue';
import SimpleParagraph from '~/components/atoms/Editorial/SimpleParagraph.vue';
import { formatPrismicImage } from '~/helpers/image-helper';
import { EMPTY_PIXEL } from '~/const/images';
export default {
  name: 'BlockOrder',
  components: {
    TitleSection: TitleSection,
    SubtitleSection: SubtitleSection,
    SimpleParagraph: SimpleParagraph,
    Cta: Cta,
    MainImage: MainImage
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: {
    bgSrc: function bgSrc() {
      var small = formatPrismicImage(this.payload.primary.background_image.url, ['w_375']) || EMPTY_PIXEL;
      var medium = formatPrismicImage(this.payload.primary.background_image.url, ['w_375,dpr_2']) || EMPTY_PIXEL;
      var large = formatPrismicImage(this.payload.primary.background_image.url, ['w_1440']) || EMPTY_PIXEL;
      var xlarge = formatPrismicImage(this.payload.primary.background_image.url, ['w_1440,dpr_2']) || EMPTY_PIXEL;
      return "\n        ".concat(small, " [(max-width: 375px)] |\n        ").concat(medium, " [(max-width: 750px)] |\n        ").concat(large, " [(max-width: 1440px)] |\n        ").concat(xlarge, " [(max-width: 2880px)]");
    },
    title: function title() {
      return {
        text: this.payload.primary.title[0] || {},
        color: this.payload.primary.title_color || ''
      };
    },
    subtitle: function subtitle() {
      return {
        text: this.payload.primary.subtitle[0] || {},
        color: this.payload.primary.subtitle_color || ''
      };
    },
    simpleParagraph: function simpleParagraph() {
      return this.payload.primary.simple_paragraph || [];
    },
    readMore: function readMore() {
      return this.payload.primary.read_more === 'Yes' || false;
    },
    buttons: function buttons() {
      return this.payload.items.map(function (item) {
        return {
          props: {
            url: item.button_url.url || '',
            textBtn: item.button_text || '',
            type: item.button_type || 'primary'
          },
          tracking: {
            data: {
              event_category: item.button_event_category || '',
              event_action: item.button_event_action || '',
              event_label: item.button_event_label || ''
            }
          }
        };
      });
    },
    alt: function alt() {
      return this.payload.primary.alt;
    },
    imgSrc: function imgSrc() {
      return formatPrismicImage(this.payload.primary.image.url, ['w_1440']) || EMPTY_PIXEL;
    },
    imgSrcset: function imgSrcset() {
      var small = formatPrismicImage(this.payload.primary.image.url, ['w_375']) || EMPTY_PIXEL;
      var medium = formatPrismicImage(this.payload.primary.image.url, ['w_375,dpr_2']) || EMPTY_PIXEL;
      var large = formatPrismicImage(this.payload.primary.image.url, ['w_1440']) || EMPTY_PIXEL;
      var xlarge = formatPrismicImage(this.payload.primary.image.url, ['w_1440,dpr_2']) || EMPTY_PIXEL;
      return "\n        ".concat(small, " 375w,\n        ").concat(medium, " 750w,\n        ").concat(large, " 1440w,\n        ").concat(xlarge, " 2880w");
    },
    ratio: function ratio() {
      return this.payload.primary.ratio || '';
    }
  }
};